// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Label = require("../../common/Components/Label.bs.js");
let AgentInfo = require("../../common/Components/AgentInfo.bs.js");
let PropertyPrice = require("../../common/Components/PropertyPrice.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let PropertyMlsLabel = require("../../common/Components/PropertyMlsLabel.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../../common/Components/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyLocationForCard = require("../../common/Components/PropertyLocationForCard.bs.js");
let PropertySearchResultCard = require("./PropertySearchResultCard.bs.js");
let RentalPropertyAttributes = require("../../common/Components/RentalPropertyAttributes.bs.js");
let PropertySearchResultActions = require("./PropertySearchResultActions.bs.js");
let UseShouldShowPropertyDetails = require("../../common/Hooks/UseShouldShowPropertyDetails.bs.js");
let PropertySearchResultTimestamp = require("./PropertySearchResultTimestamp.bs.js");
let RentalPropertySearchResult_rentalPropertyV5_graphql = require("../../../__generated__/RentalPropertySearchResult_rentalPropertyV5_graphql.bs.js");
let RentalPropertySearchResult_Agent_rentalPropertyV5_graphql = require("../../../__generated__/RentalPropertySearchResult_Agent_rentalPropertyV5_graphql.bs.js");
let RentalPropertySearchResult_StatusLabel_rentalPropertyV5_graphql = require("../../../__generated__/RentalPropertySearchResult_StatusLabel_rentalPropertyV5_graphql.bs.js");

let convertFragment = RentalPropertySearchResult_StatusLabel_rentalPropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, RentalPropertySearchResult_StatusLabel_rentalPropertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(RentalPropertySearchResult_StatusLabel_rentalPropertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, RentalPropertySearchResult_StatusLabel_rentalPropertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(RentalPropertySearchResult_StatusLabel_rentalPropertyV5_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function RentalPropertySearchResult$StatusLabel(props) {
  let match = RescriptRelay_Fragment.useFragment(RentalPropertySearchResult_StatusLabel_rentalPropertyV5_graphql.node, convertFragment, props.property);
  let fragmentRefs = match.fragmentRefs;
  switch (match.status.__typename) {
    case "ExpiredProperty" :
      return JsxRuntime.jsx(Label.Neutral.make, {
        text: "Expired"
      });
    case "RentedProperty" :
      return JsxRuntime.jsx(Label.Neutral.make, {
        text: "Rented"
      });
    case "WithdrawnProperty" :
      return JsxRuntime.jsx(Label.Neutral.make, {
        text: "Withdrawn"
      });
    case "ActiveProperty" :
    case "__unselected" :
      return JsxRuntime.jsx(PropertyMlsLabel.make, {
        property: fragmentRefs
      });
  }
}

let StatusLabel = {
  PropertyFragment: PropertyFragment,
  make: RentalPropertySearchResult$StatusLabel
};

let convertFragment$1 = RentalPropertySearchResult_Agent_rentalPropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, RentalPropertySearchResult_Agent_rentalPropertyV5_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(RentalPropertySearchResult_Agent_rentalPropertyV5_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, RentalPropertySearchResult_Agent_rentalPropertyV5_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(RentalPropertySearchResult_Agent_rentalPropertyV5_graphql.node, convertFragment$1, fRef);
}

let PropertyFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function RentalPropertySearchResult$Agent$WithoutErrorBoundary(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "small";
  let match = RescriptRelay_Fragment.useFragment(RentalPropertySearchResult_Agent_rentalPropertyV5_graphql.node, convertFragment$1, props.property);
  return JsxRuntime.jsx(AgentInfo.make, {
    agent: match.agent.fragmentRefs,
    size: size
  });
}

let WithoutErrorBoundary = {
  make: RentalPropertySearchResult$Agent$WithoutErrorBoundary
};

function RentalPropertySearchResult$Agent(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "small";
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "property agent",
    children: JsxRuntime.jsx(RentalPropertySearchResult$Agent$WithoutErrorBoundary, {
      property: props.property,
      size: size
    })
  });
}

let Agent = {
  PropertyFragment: PropertyFragment$1,
  WithoutErrorBoundary: WithoutErrorBoundary,
  make: RentalPropertySearchResult$Agent
};

let convertFragment$2 = RentalPropertySearchResult_rentalPropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, RentalPropertySearchResult_rentalPropertyV5_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(RentalPropertySearchResult_rentalPropertyV5_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, RentalPropertySearchResult_rentalPropertyV5_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(RentalPropertySearchResult_rentalPropertyV5_graphql.node, convertFragment$2, fRef);
}

let PropertyFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function RentalPropertySearchResult(props) {
  let property = RescriptRelay_Fragment.useFragment(RentalPropertySearchResult_rentalPropertyV5_graphql.node, convertFragment$2, props.property);
  let shouldShowPropertyDetails = UseShouldShowPropertyDetails.use(property.fragmentRefs);
  return JsxRuntime.jsx(PropertySearchResultCard.make, {
    property: property.fragmentRefs,
    label: JsxRuntime.jsx(RentalPropertySearchResult$StatusLabel, {
      property: property.fragmentRefs
    }),
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(PropertyLocationForCard.make, {
          property: property.fragmentRefs
        }),
        JsxRuntime.jsx(PropertyPrice.make, {
          property: property.fragmentRefs,
          size: "medium"
        }),
        JsxRuntime.jsx(RentalPropertyAttributes.make, {
          property: property.fragmentRefs,
          displayPropertyType: false
        }),
        shouldShowPropertyDetails ? JsxRuntime.jsx(RentalPropertySearchResult$Agent, {
            property: property.fragmentRefs
          }) : null,
        JsxRuntime.jsx(PropertySearchResultTimestamp.make, {
          property: property.fragmentRefs
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(PropertySearchResultActions.make, {
            property: property.fragmentRefs
          }),
          className: "mt-auto"
        })
      ],
      className: "flex h-full flex-col gap-4"
    })
  });
}

let Card;

let make = RentalPropertySearchResult;

exports.StatusLabel = StatusLabel;
exports.Agent = Agent;
exports.PropertyFragment = PropertyFragment$2;
exports.Card = Card;
exports.make = make;
/* Label Not a pure module */
